<template>
  <section class="mb-3">
    <journal-row
      v-for="(day, idx) in days"
      :key="day"
      :day="day"
      :showApply="idx === 0"
      :start_workday="data[day].start_workday"
      :end_workday="data[day].end_workday"
      @start_workday:change="(val) => (data[day].start_workday = val)"
      @end_workday:change="(val) => (data[day].end_workday = val)"
      @click:apply-to-all="handleApplyToAll"
    ></journal-row>
  </section>
</template>

<script>
import JournalRow from "./JournalRow.vue";
import { defaultJournal } from "../utils";
export default {
  components: { JournalRow },
  props: {
    initialValue: String,
  },
  data() {
    return {
      timePickers: { start_workday: false, end_workday: false },
      data: this.initialValue ? JSON.parse(this.initialValue) : { ...defaultJournal },
      days: ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"],
    };
  },

  watch: {
    initialValue(val) {
      if (val) {
        this.data = JSON.parse(val);
      }
    },
    data: {
      handler() {
        this.$emit("data:change", this.data);
      },
      deep: true,
    },
  },

  methods: {
    handleApplyToAll() {
      const newData = this.data.lunes;
      for (const key in this.data) {
        if (Object.hasOwnProperty.call(this.data, key) && key !== "lunes") {
          this.data[key] = { ...newData };
        }
      }
    },
  },
};
</script>

<style></style>
